module.exports = __webpack_public_path__ + "img/question.6c22b509.png";